import { render, staticRenderFns } from "./InitialsAvatar.vue?vue&type=template&id=d8f6dd2a&"
import script from "./InitialsAvatar.vue?vue&type=script&lang=js&"
export * from "./InitialsAvatar.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/initials-avatar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports